module.exports = __webpack_public_path__ + "img/locker.ecf4c973.svg";